import React from "react";
import { ListChecks } from "lucide-react";
import { SectionTitle, Input, Select } from "../primitives";
import { SERVICE_CATEGORIES, SERVICE_STATUSES, CURRENCIES } from "../constants";

/**
 * Categorised services matrix. Per-service: status (available / not / included /
 * extra) and optional extra-fee amount.
 */
export default function Step5Services({ form, set }) {
  const matrix = form.services_matrix || {};
  const setItem = (k, patch) =>
    set({ services_matrix: { ...matrix, [k]: { ...(matrix[k] || {}), ...patch } } });

  return (
    <div className="space-y-6">
      <SectionTitle icon={ListChecks} title="Services"
        subtitle="Be clear about what's available, included, or charged extra." />

      <div className="flex items-center gap-3">
        <span className="text-xs text-stone-400">Currency for extras:</span>
        <Select
          value={form.currency}
          onChange={(e) => set({ currency: e.target.value })}
          className="w-28 h-9"
          data-testid="services-currency"
        >
          {CURRENCIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </Select>
      </div>

      {SERVICE_CATEGORIES.map((cat) => (
        <div key={cat.k} className="rounded-xl border border-stone-800 bg-stone-950/40 overflow-hidden">
          <div className="px-4 py-3 border-b border-stone-800 bg-stone-900/40">
            <h4 className="text-sm font-medium text-amber-300 tracking-wide">{cat.label}</h4>
          </div>
          <div className="divide-y divide-stone-800/80">
            {cat.items.map((it) => {
              const entry = matrix[it.k] || { status: "" };
              return (
                <div key={it.k} className="p-3 sm:p-4 grid grid-cols-1 sm:grid-cols-[1fr_auto_auto] gap-2 sm:gap-3 sm:items-center">
                  <div className="text-sm text-stone-100">{it.label}</div>
                  <Select
                    value={entry.status || ""}
                    onChange={(e) => setItem(it.k, { status: e.target.value })}
                    className="sm:w-44 h-9"
                    data-testid={`svc-${it.k}-status`}
                  >
                    <option value="">Choose…</option>
                    {SERVICE_STATUSES.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
                  </Select>
                  {entry.status === "extra" ? (
                    <Input
                      type="number" min={0}
                      value={entry.price || ""}
                      onChange={(e) => setItem(it.k, { price: e.target.value })}
                      placeholder="Fee"
                      className="sm:w-28 h-9"
                      data-testid={`svc-${it.k}-price`}
                    />
                  ) : <div className="hidden sm:block sm:w-28" />}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
